import React from 'react';
import { Badge } from '@/components/ui/badge';
import { SPORT_STYLES, SPORT_FALLBACK } from './constants';

/**
 * Per-court column header showing dominant sport homogeneity, e.g.
 *   "Court 1" + a small badge "🟢 100% PB" or "🟡 mixed"
 */
export default function SportHomogeneityHeader({ courtNumber, info }) {
  if (!info || !info.dominant_sport) {
    return (
      <div className="flex flex-col items-center gap-1">
        <span className="font-bold uppercase tracking-tight">Court {courtNumber}</span>
        <Badge variant="outline" className="text-[10px] font-normal">
          empty
        </Badge>
      </div>
    );
  }

  const dom = info.dominant_sport;
  const sty = SPORT_STYLES[dom] || SPORT_FALLBACK;
  const isMixed = info.pct < 100 && info.sports.badminton > 0 && info.sports.pickleball > 0;
  const labelCount = info.sports[dom];
  const otherSport = dom === 'pickleball' ? 'badminton' : 'pickleball';
  const otherCount = info.sports[otherSport];

  return (
    <div
      className="flex flex-col items-center gap-1"
      data-testid={`court-header-${courtNumber}`}
    >
      <span className="font-bold uppercase tracking-tight">Court {courtNumber}</span>
      {isMixed ? (
        <Badge
          className="text-[10px] bg-orange-200 text-orange-900"
          title={`${info.sports.badminton}h badminton + ${info.sports.pickleball}h pickleball`}
        >
          mixed ({labelCount}+{otherCount}h)
        </Badge>
      ) : (
        <Badge
          className={`${sty.badge} text-[10px]`}
          title={`${labelCount} hour(s) of ${sty.label}`}
        >
          {info.pct}% {sty.label.slice(0, 1).toUpperCase()}
        </Badge>
      )}
    </div>
  );
}
